// extracted by mini-css-extract-plugin
export var container = "_sa-0";
export var inputWidth = "_sa-1";